<template>
    <div>
        <v-container grid-list-xs>
                <v-layout>
                <v-spacer></v-spacer>  
                    <v-btn class="font-weight-light"  tile color="black" dark  @click="btn_publish()"  >
                        <v-icon >publish</v-icon> publish
                    </v-btn>
                </v-layout>
                <br>
                <center>
                    <v-layout row wrap align-center>
                        <v-flex  v-for="week in week_seq" :key="week.weeknum" xs6 md3 >
                            <v-btn class="font-weight-light"  tile color="black" dark  @click="btn_select_week(week.weeknum)" 
                            v-if="select_week === week.weeknum" 
                            >{{week.date_range}}</v-btn>
                            <v-btn class="font-weight-light"  tile @click="btn_select_week(week.weeknum)" 
                            v-if="select_week !== week.weeknum" 
                            >{{week.date_range}}</v-btn>    
                        </v-flex > 
                    </v-layout>    
                </center>
                <v-divider></v-divider>
                <div v-for="item in items" :key="item.dayname" >
                    <center><h2 class="text-center font-weight-regular ma-3" >{{item.dayname}}</h2></center>
                    <v-layout row wrap align-center>
                        <v-flex  v-for=" n in item.order" :key = "n" xs6 md3 >
                            <div v-if="n.name === ''" >
                                <center><v-icon class="ml-2" 
                                @click="addItem( item.weeknum , item.dayname_only , n.seq )" >add</v-icon></center>
                            </div>
                            <div v-else align-center justify="center"> 
                                <v-row >
                                    <center><img :src="url + n.image " class="image"  width="90px" height="90px" 
                                    @click="addItem( item.weeknum ,  item.dayname_only , n.seq  )"  ></center>
                                </v-row>
                                <v-row>
                                    <center><h4 class="text-center font-weight-light" >{{n.name}}</h4></center>
                                </v-row>
                                 <v-row v-if="n.freeitem=='1'"> 
                                    <center><h5 style="color:red" class="text-center font-weight-light" 
                                    @click="addfreeitem( item.weeknum ,  item.dayname_only , n.seq )" >Free Item</h5></center>
                                </v-row>     
                                <v-row v-if="n.freeitem!='1'"> 
                                    <center><h5 style="color:blue" class="text-center font-weight-light" 
                                    @click="addfreeitem( item.weeknum ,  item.dayname_only , n.seq  )" >Sell Item</h5></center>
                                </v-row>    
                                <v-row>
                                    <v-col @click="addtag" >
                                    <center>

                                        <div v-if="n.tag == ''" class="blue-grey lighten-4 text-center mx-5">
                                            <span class="white--text">Tag</span>
                                        </div>     
                                        
                                        <div v-if="n.tag != ''"  class="blue-grey darken-1 text-center mx-5">
                                            <span class="white--text">{{n.tag}}</span>
                                        </div>     
                                    </center>                                                                                    
                                    </v-col>

                                </v-row>                                                        
                            </div>           
                        </v-flex>
                    </v-layout>
                    <br>
                        <center>+ Rows</center>
                    <br>
                    <v-divider></v-divider>
                </div>
        </v-container>
        <v-dialog v-model="dialog_s" width="450" >
            <v-card>
                <v-card-title class="headline">Select Product</v-card-title>
                    <v-container>    
                        <v-text-field
                            v-model="searchQuery"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-divider></v-divider>
                        <br>
                        <table width="100%">
                            <tr v-for="item in resultQuery" :key="item.code" @click="saveItem( post_week_num ,sel_day ,
                            sel_seq  ,item.code )"  >            
                                <td width="20%"><h4 class="font-weight-light">{{item.code}}</h4></td>
                                <td width="80%"><h4 class="font-weight-light">{{item.name}}</h4></td> 
                            </tr>
                        </table>                                
                    </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_f" width="300" >
            <v-card>
                <v-card-title class="headline">Item setup</v-card-title>
                    <v-container>
                        <p>{{sel_item_name}}</p>    
                        <v-text-field
                            v-model="free_qty"
                            label="Number of sell = Get this item free"/>   
                        <v-btn @click="savesellItem( post_week_num ,sel_day ,
                            sel_seq    )" >Sell item</v-btn>
                        <v-btn @click="savefreeItem( post_week_num ,sel_day ,
                            sel_seq   )" >Free item</v-btn>
                        <v-divider></v-divider>
                        <br>                              
                    </v-container>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import axios from "axios"
export default {

data() {
    return {
            items :[],
            products :[],
            headers:[
                { text: 'Code', value: 'code' },
                { text: 'Product name', value: 'name' },
            ],
            search : '',
            searchQuery : '',
            week_seq :[],
            dialog: false ,
            dialog_s: false,
            dialog_f: false,            
            sel_day:'',
            select_week: '0',
            post_week_num : 0 ,
            sel_seq:'',
            free_qty: 2 ,
            sel_item_name : '',
            url : "https://ws.plantifulbkk.shop/images/" ,

        }
    },
    created () {
        this.read_data_week_seq()
        this.read_data(this.select_week)
        this.read_data_product()
    },
    computed:{
        resultQuery(){
            if(this.searchQuery){
            return this.products.filter((item)=>{
                return this.searchQuery.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v))
            })
            }else{
                return this.products;
            }
        },
    },
    methods :{
        read_data(week) {
                const vm = this;
                vm.axios.get('https://ws.plantifulbkk.shop/get_weekly_menu.php',{
                params: {
                    sday: week ,
                }
                }).then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.items = result
                
            });
        },
        read_data_product() {
                const vm = this;
                
                vm.axios.get('https://ws.plantifulbkk.shop/get_product.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.products = result
                console.log(vm.products)
            }); 
        },
        read_data_week_seq() {
                const vm = this;
                
                vm.axios.get('https://ws.plantifulbkk.shop/get_set4week.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.week_seq = result
                
                
            }); 
        },
        addItem( week , day , seq ){
            this.post_week_num = week
            this.sel_day = day
            this.sel_seq =  seq
            this.dialog_s = true
        },
        addfreeitem( week , day , seq ){
            this.post_week_num = week
            this.sel_day = day
            this.sel_seq =  seq
            this.dialog_f = true
        },
        addtag(){
            alert(" add or remove tag ")
        },
        btn_publish(){

            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_publish_menu.php",{
                params: {
                    sday: this.select_week ,
                }
            }).then(result=>{
                    console.log(result.data)
                    this.read_data(this.select_week)
                    alert("Publish Weekly menu Complete!!")
                })
            .catch(function (error) {
                    alert("Error")
                    console.log(error)
                })

        },
        btn_select_week(seq){
            this.select_week =  seq
            this.read_data(this.select_week)
        },
        saveItem( week , day , seq , item ){

            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_weekly_menu.php",{
                params: {
                    sweek: week ,
                    sday: day ,
                    sseq: seq ,
                    scode: item ,
                }
            }).then(result=>{
                    console.log(result.data)
                    this.read_data(this.select_week)
                })
            .catch(function (error) {
                    alert("Error")
                    console.log(error)
                })

            this.dialog_s = false
            
        },
    
            savesellItem(  ){

            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_update_sell_item.php",{
                params: {
                    sweek: this.post_week_num ,
                    sday: this.sel_day  ,
                    sseq: this.sel_seq ,
                }
            }).then(result=>{
                    console.log(result.data)
                    this.read_data(this.select_week)
                })
            .catch(function (error) {
                    alert("Error")
                    console.log(error)
                })

            this.dialog_f = false
            
        },
    
            savefreeItem( ){

            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_update_free_item.php",{
                params: {
                    sweek: this.post_week_num ,
                    sday: this.sel_day  ,
                    sseq: this.sel_seq ,
                    sqty: this.free_qty,
                }
            }).then(result=>{
                    console.log(result.data)
                    this.read_data(this.select_week)
                })
            .catch(function (error) {
                    alert("Error")
                    console.log(error)
                })

            this.dialog_f = false
            
        },

    },
}


</script>

<style>
 
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

H2 {
  font-family: 'Mitr', sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/pages/set_weekly_menu.vue